export default "__VITE_ASSET__DzmEZdqJ__"